(function () {
  const STORAGE_PREFIX = 'mb_stoerer_view:';

  function init(root) {
    const defaultView = root.dataset.defaultView === 'grid' ? 'grid' : 'editorial';
    const handle = root.dataset.collectionHandle || '_global';
    const editorial = root.querySelector('[data-view-panel="editorial"]');
    const grid = root.querySelector('[data-view-panel="grid"]');
    const buttons = root.querySelectorAll('[data-view-toggle]');

    if (!editorial || !grid || !buttons.length) return;

    const storageKey = STORAGE_PREFIX + handle;
    let stored = null;
    try {
      stored = window.localStorage.getItem(storageKey);
    } catch (e) {
      stored = null;
    }

    let urlView = null;
    try {
      const p = new URLSearchParams(window.location.search).get('layout');
      if (p === 'grid' || p === 'editorial') urlView = p;
    } catch (e) { /* ignore */ }

    let view = urlView || (stored === 'grid' || stored === 'editorial' ? stored : defaultView);

    function apply(v) {
      const isGrid = v === 'grid';
      editorial.hidden = isGrid;
      grid.hidden = !isGrid;
      root.setAttribute('data-active-view', v);

      buttons.forEach((btn) => {
        const active = btn.getAttribute('data-view-toggle') === v;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      try {
        window.localStorage.setItem(storageKey, v);
      } catch (e) {
        /* ignore quota / private mode */
      }
    }

    apply(view);

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const next = btn.getAttribute('data-view-toggle');
        if (next === 'editorial' || next === 'grid') apply(next);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-stoerer-collection-view]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
